export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1: Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/291e1e03275d7c1cc8fd6f7c97fde4c7/812ac9616e0f541892f666a14d15c875.png"
              alt="SUPERPISCINAS FLORIN"
              className="h-20 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Especialistas en construcción, mantenimiento y limpieza de piscinas desde 2010. Calidad y confianza en cada proyecto.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-slate-300">
                <i className="ri-time-line text-cyan-400"></i>
                <span>Lun–Vie: 8:00–19:00</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-slate-300">
                <i className="ri-time-line text-cyan-400"></i>
                <span>Sáb: 9:00–14:00</span>
              </div>
            </div>
          </div>

          {/* Col 2: Links */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-widest">Navegación</h4>
            <ul className="space-y-3">
              {[
                { label: "Inicio", id: "inicio" },
                { label: "Sobre Nosotros", id: "nosotros" },
                { label: "Servicios", id: "servicios" },
                { label: "Galería", id: "galeria" },
                { label: "Contacto", id: "contacto" },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-slate-400 hover:text-cyan-400 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Services */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-widest">Servicios</h4>
            <ul className="space-y-3">
              {[
                "Construcción de Piscinas",
                "Mantenimiento",
                "Limpieza Profesional",
              ].map((s) => (
                <li key={s}>
                  <button
                    onClick={() => scrollTo("servicios")}
                    className="text-slate-400 hover:text-cyan-400 text-sm transition-colors cursor-pointer text-left"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div>
            <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-widest">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-slate-400">
                <i className="ri-map-pin-line text-cyan-400 mt-0.5 flex-shrink-0"></i>
                <span>Calle Huesca, 20, Villarrubia de los Ojos, 13670</span>
              </li>
              <li>
                <a href="tel:+34642885747" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400 transition-colors">
                  <i className="ri-phone-line text-cyan-400"></i>
                  642 885 747
                </a>
              </li>
              <li>
                <a href="tel:+34642452237" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400 transition-colors">
                  <i className="ri-phone-line text-cyan-400"></i>
                  642 452 237
                </a>
              </li>
              <li>
                <a href="mailto:info@superpiscinas.es" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400 transition-colors">
                  <i className="ri-mail-line text-cyan-400"></i>
                  info@superpiscinas.es
                </a>
              </li>
            </ul>

            {/* Social */}
            <div className="mt-6">
              <p className="text-slate-400 text-xs uppercase tracking-widest mb-3">Síguenos</p>
              <div className="flex gap-3">
                {[
                  { icon: "ri-tiktok-line", href: "https://www.tiktok.com/@superpicinasflorentin?lang=es-419" },
                  { icon: "ri-facebook-circle-line", href: "https://www.facebook.com/dobre.florentin.7" },
                  { icon: "ri-whatsapp-line", href: "https://wa.me/34642885747" },
                ].map((s) => (
                  <a
                    key={s.icon}
                    href={s.href}
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="w-9 h-9 flex items-center justify-center bg-slate-700 hover:bg-cyan-500 rounded-lg transition-all cursor-pointer"
                  >
                    <i className={`${s.icon} text-base`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">
            © 2025 SUPERPISCINAS FLORIN. Todos los derechos reservados.
          </p>
          <p className="text-slate-500 text-xs">
            Diseñado con <span className="text-cyan-400">♥</span> para nuestros clientes
          </p>
        </div>
      </div>
    </footer>
  );
}
